import axios from 'axios';

export const getFnsData = async (taxId: string) => {
	try {
		const { data } = await axios.post<{
			suggestions: any[];
		}>(
			'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party',
			{
				query: taxId,
				branch_type: 'MAIN',
			},
			{
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					Authorization: `Token ${process.env.DADATA}`,
				},
			},
		);

		if (!data || !Array.isArray(data.suggestions) || !data.suggestions.length) {
			return null;
		}

		return data.suggestions[0].data['name']['full_with_opf'];
	} catch (error) {
		console.error(error);
		throw 'Ошибка получения данных ДаДата';
	}
};
